import * as React from 'react'

import { Input } from './input'
import { EyeIcon, EyeOffIcon } from 'lucide-react'


// eslint-disable-next-line no-unused-vars
const PasswordInput = React.forwardRef(({ className, ...props }, ref) => {
  const [isPasswordVisible, setIsPasswordVisible] = React.useState(false)
  return (
    <Input
      suffix={
        isPasswordVisible ? (
            <EyeIcon strokeWidth={1.5} className='w-15 h-15 cursor-pointer text-gray-600' onClick={() => setIsPasswordVisible(!isPasswordVisible)} />
        ) : (
          <EyeOffIcon strokeWidth={1.5} className='w-15 h-15 cursor-pointer text-gray-600' onClick={() => setIsPasswordVisible(!isPasswordVisible)} />
        )
      }
      type={isPasswordVisible ? 'text' : 'password'}
      {...props}
      ref={ref}
    />
  )
})
PasswordInput.displayName = 'PasswordInput'

export { PasswordInput }